// Thumbnails van eigen video's (3 nov 2026). De Frame.io-thumbs zijn verlopen (403); de engine
// geeft nu een korte SAS-link naar een keyframe uit onze eigen opslag. Heeft een video geen
// keyframe maar wel een bestand (`thumb_maken`), dan halen we één keer
// /videos/{id}/thumbnail op: de engine maakt de still en bewaart hem privé.
// Een <img> kan geen Bearer-token meesturen, daarom gaat dat via authFetch.
import { useEffect, useState } from 'react';
import { AI_ENGINE_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

const API_BASE = `${AI_ENGINE_URL}/api/v1/video-search`;
const MAX_TEGELIJK = 3;   // zelfde rij als de engine: geen 48 verzoeken tegelijk

const GELDIG_MS = 3 * 60 * 60 * 1000;  // de SAS van de engine leeft 4 uur
const OPNIEUW_MS = 60 * 1000;          // na een fout (netwerk, 503) een minuut later nog eens

const cache = new Map();  // video-id → { belofte: Promise<string|null>, tot: ms }
const wachtrij = [];
let bezig = 0;

function klaarMet() {
  bezig -= 1;
  volgende(); // eslint-disable-line no-use-before-define
}

function start({ id, klaar }) {
  bezig += 1;
  authFetch(`${API_BASE}/videos/${id}/thumbnail`)
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => klaar(d?.url || null))
    .catch(() => klaar(null))
    .finally(klaarMet);
}

function volgende() {
  while (bezig < MAX_TEGELIJK && wachtrij.length) start(wachtrij.shift());
}

function haalThumb(id) {
  const oud = cache.get(id);
  if (oud && oud.tot > Date.now()) return oud.belofte;
  const regel = { tot: Infinity };   // zolang hij loopt: niet dubbel vragen
  regel.belofte = new Promise((klaar) => { wachtrij.push({ id, klaar }); volgende(); })
    .then((url) => { regel.tot = Date.now() + (url ? GELDIG_MS : OPNIEUW_MS); return url; });
  cache.set(id, regel);
  return regel.belofte;
}

// src = wat de lijst al gaf; maken = de engine kan er een maken.
export function useEigenThumb(id, src, maken) {
  const [url, setUrl] = useState(src || null);
  useEffect(() => {
    setUrl(src || null);
    if (src || !maken || id == null) return undefined;
    let actief = true;
    haalThumb(id).then((u) => { if (actief && u) setUrl(u); });
    return () => { actief = false; };
  }, [id, src, maken]);
  return url;
}
